module.exports = __webpack_public_path__ + "static/007-1612dd8e1bb013ca6a03cae83fd4a5c7.jpg";